import 'bootstrap/dist/css/bootstrap.min.css';
import { CiLocationOn, CiMail, CiPhone } from "react-icons/ci";
import 'aos/dist/aos.css';

import './_responsive.scss';

export default function Header() {
  return (
    <section id="section-bartop" className="w-full bg-[#a1a1a1] text-sm">
      <div className="container mx-auto flex flex-col md:flex-row flex-wrap justify-between items-center py-2 px-4 gap-3">
        <div
          className="flex items-center gap-2"
          data-aos="fade-zoom-in"
          data-aos-duration="1000"
          data-aos-delay="300"
          data-aos-offset="0"
        >
          <CiLocationOn size={25} />
          <a
            href="https://goo.gl/maps/n7nbaKd2LzL6Kss38"
            target="_blank"
            rel="noopener noreferrer"
            className="no-underline text-[#333] hover:underline"
          >
            Av. Tupinambá, 498 - Parque dos Carajás, Parauapebas - PA
          </a>
        </div>

        <div
          className="flex items-center gap-2"
          data-aos="fade-zoom-in"
          data-aos-duration="1000"
          data-aos-delay="300"
          data-aos-offset="0"
        >
          <CiMail size={25} />
          <a
            href="mailto:seculos@gruposeculos.com.br"
            className="no-underline text-[#333] hover:underline"
          >
            seculos@seculosengenharia.com.br
          </a>
        </div>

        <div
          className="flex items-center gap-2"
          data-aos="fade-zoom-in"
          data-aos-duration="1000"
          data-aos-delay="300"
          data-aos-offset="0"
        >
          <CiPhone size={25} />
          <a
            href="tel:9433461014"
            target="_blank"
            rel="noopener noreferrer"
            className="no-underline text-[#333] hover:underline"
          >
            (94) 3346-1014 / 3346-6200
          </a>
        </div>
      </div>
    </section>
  );
}
